import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { RegionAction } from "./region.action";
import { RegionState } from "./region.model";

const INITIAL_STATE: RegionState = {
	regions: [],
};

export const regionReducer = createReducer(
	INITIAL_STATE,
	on(RegionAction.getAllSuccess, (state, { regions }) => updateState(state, { regions }))
);
